<template>
  <div>
<!--    <file-upload-->
<!--      @input="updateValue"-->
<!--      :multiple="false"-->
<!--      :post-action="postAction"-->
<!--      :drop="true"-->
<!--      :drop-directory="true"-->
<!--      :extensions="'gif,jpg,jpeg,png,webp'"-->
<!--      @input-file="inputFile"-->
<!--      v-model="files"-->
<!--      ref="upload"-->
<!--      class="fd-w-full"-->
<!--      :name="name"-->
<!--    >-->
      <div class="pri-image fd-cursor-pointer" @click="openBrowser">
        <input type="file" ref="file" @change="selectFile" style="display: none">
        <div v-if="option && !image.blob" class="fd-w-full fd-h-full object-cover">
          <img class="fd-w-full fd-h-full fd-object-cover" :src="option.url" alt="Cover">
        </div>
        <div v-else-if="!image.blob">
          <SvgLoader :name="'downloadIcon'" class="fd-mx-auto" />
          <span class="fd-block fd-text-sm fd-font-normal fd-mt-2">{{ $t('uploader.uploadYourPhoto') }}</span>
        </div>
        <div
          v-else
          class="fd-relative fd-w-full fd-h-full fd-overflow-hidden"
        >
              <span
                class="fd-absolute fd-w-full fd-h-full fd-left-0 fd-top-0"
                style="background-color: #BEC9C2; opacity: 0.61; direction: rtl;"
                :style="{left: (image.progress) + '%'}"
              />
          <img class="fd-w-full fd-h-full" :src="image.blob" alt="Cover">
        </div>
      </div>
<!--    </file-upload>-->
  </div>
</template>

<script>
import { BToast, BButton } from 'bootstrap-vue'

export default {
  name: "UploadPhoto",
  components: {BToast, BButton},
  props: {
    postAction: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    option: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      files: [],
      image: {
        blob: null,
        progress: 0
      },
      selectedFile: null,
      fileName: null,
      type: null
    }
  },
  watch: {
    selectedFile: {
      handler() {
        if (!this.selectedFile) return
        const fileName = this.selectedFile.name.split('.')
        this.fileName = fileName[0]
        this.type = this.name

        let formData = new FormData()
        formData.append('media', this.selectedFile)
        formData.append('name', this.fileName)
        formData.append('type', this.type)

        let URL = window.URL || window.webkitURL
        this.image = {
          blob: URL.createObjectURL(this.selectedFile),
          progress: 0
        }

        const config = {
          onUploadProgress: progressEvent => {
            let percentComplete = progressEvent.loaded / progressEvent.total
            this.image.progress = parseInt(percentComplete * 100);
          }
        }

        this.$store.dispatch('project/uploadFile', {
          data: formData,
          url: this.postAction,
          config
        })
          .then(() => {
            this.$emit('refreshData')
          })
          .catch(() => {
            this.image = {
              blob: null,
              progress: 0
            }
          })
          .finally(() => {
            this.selectedFile = null
          })
      },
      deep: true
    },
  },
  methods: {
    openBrowser() {
      this.$refs.file.click()
    },

    selectFile() {
      this.selectedFile = this.$refs.file.files[0]
      this.$refs.file.value = ''
      // this.newImageUrl = URL.createObjectURL(this.image)
    },
    updateValue(value) {
      this.files = value
    },
    // inputFile(newFile, oldFile) {
    //   if (newFile && !oldFile) {
    //     // Add file
    //     newFile.blob = ''
    //     let URL = window.URL || window.webkitURL
    //     if (URL && URL.createObjectURL) {
    //       newFile.blob = URL.createObjectURL(newFile.file)
    //     }
    //   }
    //
    //   if (newFile && oldFile) {
    //     // Update file
    //
    //     // Start upload
    //     if (newFile.active !== oldFile.active) {
    //       console.log('Start upload', newFile.active, newFile)
    //
    //       // min size
    //       if (newFile.size >= 0 && newFile.size < 100 * 1024) {
    //         newFile = this.$refs.upload.update(newFile, {error: 'size'})
    //       }
    //     }
    //
    //     // Upload progress
    //     console.log('progress1111', newFile.progress, oldFile.progress)
    //     if (newFile.progress !== oldFile.progress) {
    //       console.log('progress', newFile.progress, newFile)
    //     }
    //
    //     // Upload error
    //     if (newFile.error !== oldFile.error) {
    //       this.$refs.upload.remove(newFile)
    //       this.makeToast()
    //       console.log('error', newFile.error, newFile)
    //     }
    //
    //     // Uploaded successfully
    //     if (newFile.success !== oldFile.success) {
    //       console.log('success', newFile.success, newFile)
    //     }
    //   }
    //
    //   if (!newFile && oldFile) {
    //     // Remove file
    //
    //     // Automatically delete files on the server
    //     if (oldFile.success && oldFile.response.id) {
    //       // $.ajax({
    //       //   type: 'DELETE',
    //       //   url: '/file/delete?id=' + oldFile.response.id,
    //       // });
    //     }
    //   }
    //
    //   // Automatic upload
    //   if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
    //     if (!this.$refs.upload.active) {
    //       this.$refs.upload.active = true
    //     }
    //   }
    // },
    makeToast() {
      this.$bvToast.toast('Toast body content', {
        title: 'Error',
        toaster: 'b-toaster-top-right',
        variant: 'danger',
        solid: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pri-image {
  width: 100%;
  height: 457px;
  background-color: #DCDCDC;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #838883;
  border-radius: 1px;

  & label {
    cursor: pointer !important;
  }
}
</style>